import React from "react";
import Remote from "../LoaderRemote";
import styles from "./FloorPlan.module.css";
import Image from "next/image";

const FloorPlan = () => {
  const TabItem = ({ children, isActive }) => {
    return (
      <div
        className={
          "px-4 pt-3 pb-5 lg:p-0 text-white  lg:bg-primary lg:text-white lg:mr-12 whitespace-nowrap " +
          (isActive ? "bg-white text-primary" : "")
        }
      >
        {children}
      </div>
    );
  };

  return (
    <div className={"w-full lg:mt-5  " + styles.bg}>
      <div className="overflow-x-auto flex-nowrap flex  font-bold text-15 tracking-11 lg:leading-[40px] bg-primary lg:rounded-tl-lg lg:rounded-tr-lg px-2 sm:px-[1.3rem] lg:px-9 pt-20 lg:py-5 -mt-11 lg:mt-0">
        <TabItem isActive="1">ZEMIN KAT</TabItem>
        <TabItem>KAT 1</TabItem>
        <TabItem>KAT 2</TabItem>
        <TabItem>KAT 3</TabItem>
      </div>

      <div className="flex px-3 lg:pl-8 lg:pr-9 lg:pt-10 flex-col lg:flex-row lg:bg-white lg:bg-transparent before:content-[''] before:h-[189px] before:absolute before:bg-white before:w-full before:left-0">
        <div className={styles.mobileShadow}>
          <ul className={styles.tabs}>
            <li>Salon</li>
            <li>Teras</li>
            <li className={styles.active}>Yatak Odası 1</li>
            <li>Yatak Odası 2</li>
            <li>Bahçe</li>
          </ul>
        </div>

        <div className="lg:w-8/12">
          <div className="w-full">
            <div className="relative h-60">
              <Image
                alt="TEst"
                className="rounded-md"
                src="villavillam_villa_disney_duo_kiralama-24_1200x800_451.jpg"
                objectFit="cover"
                layout="fill"
                placeholder="blur"
                blurDataURL={
                  "https://cdn.villavillam.com.tr/uploads/50/villavillam_villa_disney_duo_kiralama-24_1200x800_451.jpg"
                }
                loader={Remote}
              ></Image>
            </div>
            <ul className="mt-4 lg:mt-8 ml-6 lg:ml-3 list-disc text-[#0A97B9] flex flex-wrap">
              <li className="text-sm w-1/2 mt-3">
                <span className="text-black">Çift Kişilik Yatak</span>
              </li>
              <li className="text-sm w-1/2 mt-3">
                <span className="text-black">Banyo Çift Kişilik Yatak</span>
              </li>
              <li className="text-sm w-1/2 mt-3">
                <span className="text-black">Jakuzi</span>
              </li>
              <li className="text-sm w-1/2 mt-3">
                <span className="text-black">Jakuzi,Klima</span>
              </li>
              <li className="text-sm w-1/2 mt-3">
                <span className="text-black">Klima</span>
              </li>
              <li className="text-sm w-1/2 mt-3">
                <span className="text-black">TV</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloorPlan;
